import { getLangForLocale } from './formatDate';

export function is12HourFormat(language) {
  const langForRegion = getLangForLocale(language);
  const dateTimeFormat = Intl.DateTimeFormat(langForRegion, { hour: 'numeric' });
  const dateString = dateTimeFormat.format(new Date());

  return /am|pm/i.test(dateString);
}

export default is12HourFormat;
